import axios from 'axios';
import Vue from 'vue'
import i18n from "@/i18n";

export default {

    getOrders (page, pageSize, showDrafts,status,customerId,start,end,current,showUnsynchronisedOrders) {
        return axios.get('/api/orders/list', { params: { page: page, pageSize: pageSize, showDrafts: showDrafts , status:status,customerId:customerId, start:start,end:end,current:current,showUnsynchronisedOrders:showUnsynchronisedOrders} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getOrder (orderId) {
        return axios.get('/api/orders/order', { params: { orderId: orderId } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getOrdersByCustomer (page, pageSize,supplierId, onlyDrafts,status,current,start,end) {
        return axios.get('/api/orders/customer/list', { params: { page: page, pageSize: pageSize,supplierId:supplierId, showDrafts: onlyDrafts, status : status,current:current, start:start,end:end} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    addLineToOrder (orderId, itemId, quantity, promotionId , isChecked) {
        var orderLine = {orderId: orderId, itemId: itemId, quantity: quantity, promotionId: promotionId,isCashPaymentDiscountChecked:isChecked }
        
        return axios.post('/api/orders/line/add', orderLine)
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    editLineToOrder (orderId, itemId, quantity, supplierId, promotionId, isChecked) {
        var orderLine = {orderId: orderId, itemId: itemId, quantity: quantity, supplierId: supplierId, promotionId:promotionId,isCashPaymentDiscountChecked:isChecked}
        
        return axios.post('/api/orders/line/edit', orderLine)
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    submitOrder (orderId, message, priority, deliveryAddress, isChecked,desiredDeliveryDate,promotionCode) {    
        var request = {orderId: orderId, message: message, priority: priority, deliveryAddress: deliveryAddress,isCashPaymentDiscountChecked:isChecked,desiredDeliveryDate:desiredDeliveryDate,promotionCode:promotionCode}    
        return axios.post('/api/orders/submit', request)
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success(i18n.t('services.orders.submitOrder'));
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error); return false;})
    },

    checkOrder (orderId, message, priority, deliveryAddress, isChecked,desiredDeliveryDate,promotionCode) {    
        var request = {orderId: orderId, message: message, priority: priority, deliveryAddress: deliveryAddress,isCashPaymentDiscountChecked:isChecked,desiredDeliveryDate:desiredDeliveryDate,promotionCode:promotionCode}    
        return axios.post('/api/orders/check', request)
        .then(response => {
            if (response && response.data) {
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error); return false;})
    },

    getCustomerDeliveryAddresses () {
        return axios.get('/api/orders/customer/deliveryAdresses')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    removeOrderLine (orderId, itemId, supplierId,isChecked) {
        var orderLine = {orderId: orderId, itemId: itemId, supplierId: supplierId,isCashPaymentDiscountChecked:isChecked}
        return axios.post('/api/orders/remove',orderLine )
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getOrderLines(orderId) {
        return axios.get('/api/orders/order',{params: {orderId: orderId}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    removeDraft (draft) {
        return axios.post('/api/orders/draft/remove', draft)
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    confirmOrder (orderId, deliveryMode,provisionalDeliveryDate) {
        return axios.post('/api/orders/confirmOrder', { orderId: orderId, deliveryMode: deliveryMode,provisionalDeliveryDate:provisionalDeliveryDate  } )
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getOrdersCount(status){
        return axios.get('/api/orders/count/',{ params: { status:status} })
        .then(response => {
            if (response && response.data)  return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    exportOrdersListExcel(page, pageSize, showDrafts,status,customerId,start,end,showDetails,showUnsynchronisedOrders){
        return axios({
            url:'/api/orders/export/excel/list',
            params: { page: page, pageSize: pageSize, showDrafts: showDrafts , status:status,customerId:customerId, start:start,end:end,showDetails:showDetails,showUnsynchronisedOrders:showUnsynchronisedOrders},
            method: 'GET',
            responseType: 'blob', // important
          }).then((response) => {
              if(response && response.data){
                const blob = new Blob(
                    [response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' })
                    const aEle = document.createElement('a');     // Create a label
                    const href = window.URL.createObjectURL(blob);       // Create downloaded link
                    aEle.href = href;
                    aEle.download = response.headers["filename"];  // File name after download
                    document.body.appendChild(aEle);
                    aEle.click();     // Click to download
                    document.body.removeChild(aEle); // Download complete remove element
                    window.URL.revokeObjectURL(href) // Release blob object
              }else{
                Vue.prototype.$snotify.error(i18n.t('services.main.500error'));
              }

                
          });
    },

    export(page, pageSize, showDrafts,status,customerId,start,end,showDetails,showUnsynchronisedOrders){
        return axios({
            url:'/api/orders/export/excel/check',
            params: { page: page, pageSize: pageSize, showDrafts: showDrafts , status:status,customerId:customerId, start:start,end:end,showDetails:showDetails,showUnsynchronisedOrders:showUnsynchronisedOrders},
            method: 'GET',
          }).then(() => {
            
            return this.exportOrdersListExcel(page, pageSize, showDrafts,status,customerId,start,end,showDetails,showUnsynchronisedOrders);
                
        }).catch(error => {Vue.prototype.$snotify.error(error);});
    },

    exportEXCEL(orderId){
        axios({
            url:'/api/orders/export/excel/'+orderId,
            method: 'GET',
            responseType: 'blob', // important
          }).then((response) => {
            const blob = new Blob(
                [response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' })
                const aEle = document.createElement('a');     // Create a label
                const href = window.URL.createObjectURL(blob);       // Create downloaded link
                aEle.href = href;
                aEle.download = response.headers["filename"];  // File name after download
                document.body.appendChild(aEle);
                aEle.click();     // Click to download
                document.body.removeChild(aEle); // Download complete remove element
                window.URL.revokeObjectURL(href) // Release blob object
          });
    },

    exportOrder(orderId){
        return axios({
            url:'/api/orders/export/excel/'+orderId,
            method: 'GET',
          }).then(() => {
            
            return this.exportEXCEL(orderId);
                
        }).catch(error => {Vue.prototype.$snotify.error(error);});
    },

    restartSync(orderId){
        return axios.post('/api/orders/restartSync/'+orderId )
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success(i18n.t('services.orders.syncSuccess'));
                return response.data;
            }
            else{
                {Vue.prototype.$snotify.error(i18n.t('services.orders.syncError'));}
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    }
}

